<template>
    <div style="height: 100%">
        <nav-bar/>
        <v-navigation-drawer
                app
                permanent
        >

            <v-list-item v-if="getUser">
                <v-list-item-content>
                    <v-list-item-title class="title">
                        {{getUser.firstName}} {{getUser.lastName}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list
                    dense
                    nav
            >
                <v-list-item
                        v-for="item in availableItems"
                        :key="item.title"
                        :to="{ name: item.link}"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>


        <v-main style="height: 100%">
            <router-view/>
        </v-main>
        <page-footer/>
    </div>


</template>

<script>

    import NavBar from "../components/NavBar/NavBar";
    import PageFooter from "../components/PageFooter/PageFooter";
    import {mapGetters} from "vuex";

    export default {
        components: {
            NavBar, PageFooter
        },
        data () {
            return {
                items: [
                    {
                        title: 'Dashboard',
                        icon: 'mdi-monitor-dashboard',
                        link: 'home',
                    },
                    { title: 'Speedy', icon: 'mdi-run-fast', link: 'speedy' },
                    { title: 'Bookings', icon: 'mdi-checkbook', link: 'bookings' },
                    { title: 'Customers', icon: 'mdi-domain', link: 'customers' },
                    { title: 'Trainers', icon: 'mdi-school-outline', link: 'trainers' },
                    { title: 'Purchase Orders', icon: 'mdi-handshake', link: 'purchase-orders' },
                    { title: 'Debtors', icon: 'mdi-handshake', link: 'debtors' },
                    {
                        title: 'Settings',
                        icon: 'mdi-cog',
                        link: 'settings',
                        requiredPermission: 'setting-read'
                    },
                    { title: 'Leads', icon: 'fas fa-seedling', link: 'leads' },
                    {
                        title: 'Emails',
                        icon: 'mdi-mail',
                        link: 'emails',
                        requiredRole: 'administrator'
                    },
                    {
                        title: 'Users',
                        icon: 'mdi-account',
                        link: 'users',
                        requiredRole: 'administrator'
                    },
                ],
                right: null,
            }
        },
        computed: {
            ...mapGetters('auth', [
                'isAuthenticated',
                'getUser',
                'hasPermission',
                'hasRole',
            ]),

            availableItems() {
                let list = []
                let view = this
                this.items.forEach((item) => {
                    if(item.requiredPermission && !view.hasPermission(item.requiredPermission)){
                        return
                    }
                    if(item.requiredRole && !view.hasRole(item.requiredRole)){
                        return
                    }
                    list.push(item)

                })
                return list
            }

        },
        methods: {
            logout() {
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            }
        }
    };
</script>
